import { render, staticRenderFns } from "./LDSystem.vue?vue&type=template&id=1527636d&scoped=true"
import script from "./LDSystem.vue?vue&type=script&lang=js"
export * from "./LDSystem.vue?vue&type=script&lang=js"
import style0 from "./LDSystem.vue?vue&type=style&index=0&id=1527636d&prod&lang=scss"
import style1 from "./LDSystem.vue?vue&type=style&index=1&id=1527636d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1527636d",
  null
  
)

export default component.exports